import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration from config module

/**
 * Class representing a view for displaying income data in a table.
 * @extends JetView
 */
export default class tableIncomesView extends JetView {
    /**
     * Defines the configuration for the table incomes view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            id: 'datatable',
            // Apply CSS classes for styling
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Set the height based on screen width
            height: screen.width < 500 ? 400 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Editar', // Tooltip for edit action
                    template: function(obj) {
                        // Return an HTML string for the edit icon
                        return '<span class=\'webix_icon wxi-close edit\'></span>';
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                {
                    id: 'Consecutive',
                    header: 'Consecutivo', // Consecutive number column
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: 'Descripción', // Description column
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'), // Creation date column with localization
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text', // Sort by text
                    format: dateFormat, // Format the date
                },
                {
                    id: 'TypeIncomes',
                    header: 'Tipo de Ingreso', // Income type column
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'DocumentID',
                    header: 'Documento ID', // Document ID column
                    width: 150,
                    sort: 'int',
                },
                { id: 'Concept', header: 'Concepto', width: 150, sort: 'int' }, // Concept column
                { id: 'Value', header: 'Valor', width: 150, sort: 'int' }, // Value column
                { id: 'Iva', header: 'IVA', width: 150, sort: 'int' }, // VAT column
                {
                    id: 'Retraccion',
                    header: 'Retracción', // Retraction column
                    width: 150,
                    sort: 'int',
                },
            ],
            // Define click event for the edit icon
            onClick: {
                edit: function(euv, id) {
                    // Show the edit form when the edit icon is clicked
                    $$('EditIncomes').show();
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
            pager: 'pagerA', // Define the pager ID
            // Set the URL for fetching data with user parameter
            url: devConfig.geturlApi() + 'BetShop/GetIncomes?FromId=' + cur_user + '&',
            // Initial data for the datatable
            data: [
                {
                    Id: '01',
                    IsBetShop: 0,
                    CreatedLocalDate: '2019-02-03',
                    Description: 'Compra', // Description of the first entry
                    TypeIncomes: 'Tipo Ingreso 1', // Type of income for the first entry
                    DocumentID: '1010',
                    Value: '100', // Value of the first entry
                    Iva: '10', // VAT for the first entry
                    Retraccion: '10', // Retraction for the first entry
                    Concept: 'Concepto 1', // Concept for the first entry
                },
                {
                    Id: '02',
                    IsBetShop: 1,
                    Description: 'Servicio', // Description of the second entry
                    CreatedLocalDate: '2019-02-03',
                    TypeIncomes: 'Tipo Ingreso 2', // Type of income for the second entry
                    DocumentID: '1010',
                    Value: '1', // Value of the second entry
                    Iva: '10', // VAT for the second entry
                    Retraccion: '10', // Retraction for the second entry
                    Concept: 'Concepto 2', // Concept for the second entry
                },
            ],
            // Define double-click event for items
            on: {
                onItemDblClick: (id) => {
                    // Show the edit form on double-click
                    $$('EditIncomes').show();
                },
            },
        }; // Placeholder for configuration content
    }

    /**
     * Initializes the table incomes view.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        /**
         * Initializes variables and configures the popup for adding incomes.
         */
        var url = grid.data.url; // URL for fetching grid data
        const cur_user = this.getParam('user', true); // Retrieves the current user parameter
        var filter = ''; // Filter string for data fetching
        var datePopup3 = []; // Array to store concepts data
        var datePopup4 = []; // Array to store types of center position data
        var popupAdd = ''; // Popup configuration
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Current date in formatted string

        /**
         * Fetches concepts data for the popup form.
         */
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Sets the content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function(text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Displays an error message on failure
                },
                success: function(text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses the response
                    datePopup3 = resp.Data; // Stores concepts data

                    /**
                     * Fetches types of center position data for the popup form.
                     */
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Sets the content type for the request
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', '{"Type":2}', {
                            error: function(text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Displays an error message on failure
                            },
                            success: function(text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parses the response
                                datePopup4 = resp.Data; // Stores types of center position data

                                /**
                                 * Configures and initializes the popup for adding incomes.
                                 */
                                popupAdd = webix.ui({
                                    view: 'window', // Popup window
                                    width: 750, // Width of the popup
                                    id: 'AddIncomes', // Unique ID for the popup
                                    head: {
                                        view: 'toolbar', // Toolbar for the popup header
                                        cols: [
                                            {
                                                view: 'label', // Label for the popup title
                                                label: 'Añadir Gasto',
                                            },
                                            {
                                                view: 'icon', // Close icon
                                                icon: 'wxi-close',
                                                click: function() {
                                                    this.getTopParentView().hide(); // Hides the popup on click
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Centers the popup
                                    modal: true, // Enables modal behavior
                                    body: {
                                        view: 'form', // Form inside the popup
                                        id: 'addform', // Unique ID for the form
                                        elements: [
                                            {
                                                margin: 10, // Margin for the form elements
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for description
                                                        label: 'Descripción',
                                                        name: 'Description',
                                                        labelWidth: 140,
                                                        required: true, // Marks the field as required
                                                    },
                                                    {
                                                        view: 'text', // Text input for creation date
                                                        label: 'Fecha de Creación',
                                                        labelWidth: 140,
                                                        name: 'CreatedLocalDate',
                                                        value: createdLocalDate, // Pre-filled with the current date
                                                        readonly: true, // Read-only field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for income type
                                                        label: 'Tipo de Ingreso',
                                                        name: 'TypeIncomes',
                                                        labelWidth: 140,
                                                        options: datePopup4, // Options fetched from the server
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Dropdown for concept
                                                        label: 'Concepto',
                                                        name: 'Concept',
                                                        labelWidth: 140,
                                                        options: datePopup3, // Options fetched from the server
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for document ID
                                                        label: 'Documento ID',
                                                        name: 'DocumentID',
                                                        labelWidth: 140,
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for value
                                                        label: 'Valor',
                                                        name: 'Value',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for IVA
                                                        label: 'IVA',
                                                        name: 'Iva',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                    {
                                                        view: 'text', // Text input for retraction
                                                        label: 'Retracción',
                                                        name: 'Retraccion',
                                                        type: 'number', // Numeric input
                                                        labelWidth: 100,
                                                        required: true,
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button
                                                        value: 'Cancelar',
                                                        click: function() {
                                                            this.getTopParentView().hide(); // Hides the popup
                                                            $$('addform').setValues($$('addform').getCleanValues()); // Resets the form
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button
                                                        type: 'form',
                                                        value: 'Guardar',
                                                        click: function($e) {
                                                            var values = $$('addform').getValues(); // Retrieves form values
                                                            if ($$('addform').validate()) {
                                                                // Validates the form
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Sets content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() + 'BetShop/Incomes', // API endpoint
                                                                        '{"Description":"' +
                                                                        values.Description +
                                                                        '", "CreatedLocalDate":"' +
                                                                        values.CreatedLocalDate +
                                                                        '", "TypeIncomes":"' +
                                                                        values.TypeIncomes +
                                                                        '"  , "BetShop":"' +
                                                                        cur_user +
                                                                        '" , "Concept":"' +
                                                                        values.Concept +
                                                                        '" , "DocumentID":"' +
                                                                        values.DocumentID +
                                                                        '"  , "Value":"' +
                                                                        values.Value +
                                                                        '", "Iva":"' +
                                                                        values.Iva +
                                                                        '", "Retraccion":"' +
                                                                        values.Retraccion +
                                                                        '"}',
                                                                        {
                                                                            error: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Displays error message
                                                                            },
                                                                            success: function(
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Gasto Agregado'); // Displays success message
                                                                                grid.clearAll(); // Clears the grid data
                                                                                grid.load(
                                                                                    url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter,
                                                                                );
                                                                                webix
                                                                                    .ui({
                                                                                        view: 'window',
                                                                                        head: {
                                                                                            view: 'toolbar',
                                                                                            cols: [
                                                                                                {
                                                                                                    view: 'label',
                                                                                                    label: 'Factura',
                                                                                                },
                                                                                                {
                                                                                                    view: 'button',
                                                                                                    label: 'X',
                                                                                                    width: 100,
                                                                                                    align: 'right',
                                                                                                    click: '$(\'windowfact2\').close();',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                        id: 'windowfact2',
                                                                                        modal: true,
                                                                                        position: 'center',
                                                                                        body: {
                                                                                            rows: [
                                                                                                {
                                                                                                    template:
                                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>',
                                                                                                },
                                                                                            ],
                                                                                        },
                                                                                    })
                                                                                    .show();
                                                                                var reader = new FileReader();
                                                                                reader.onload = function(event) {
                                                                                    $$('pdf').clear();
                                                                                    $$('pdf').parse({
                                                                                        data: event.target.result,
                                                                                    });
                                                                                };

                                                                                function b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                    sliceSize,
                                                                                ) {
                                                                                    contentType = contentType || '';
                                                                                    sliceSize = sliceSize || 512;
                                                                                    var byteCharacters = atob(b64Data);
                                                                                    var byteArrays = [];
                                                                                    for (
                                                                                        var offset = 0;
                                                                                        offset < byteCharacters.length;
                                                                                        offset += sliceSize
                                                                                    ) {
                                                                                        var slice =
                                                                                            byteCharacters.slice(
                                                                                                offset,
                                                                                                offset + sliceSize,
                                                                                            );
                                                                                        var byteNumbers = new Array(
                                                                                            slice.length,
                                                                                        );
                                                                                        for (
                                                                                            var i = 0;
                                                                                            i < slice.length;
                                                                                            i++
                                                                                        ) {
                                                                                            byteNumbers[i] =
                                                                                                slice.charCodeAt(i);
                                                                                        }
                                                                                        var byteArray = new Uint8Array(
                                                                                            byteNumbers,
                                                                                        );
                                                                                        byteArrays.push(byteArray);
                                                                                    }
                                                                                    var blob = new Blob(byteArrays, {
                                                                                        type: contentType,
                                                                                    });
                                                                                    return blob;
                                                                                }

                                                                                var contentType = 'application/pdf';
                                                                                var b64Data = data.Pdf;
                                                                                var blob = b64toBlob(
                                                                                    b64Data,
                                                                                    contentType,
                                                                                );
                                                                                var file =
                                                                                    window.URL.createObjectURL(blob);
                                                                                console.log(blob);
                                                                                document.querySelector('iframe').src =
                                                                                    file;
                                                                                var printWindow = window.open(
                                                                                    file,
                                                                                    '',
                                                                                    'width=800,height=500',
                                                                                );
                                                                                printWindow.print();
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addform').setValues($$('addform').getCleanValues()); // Resets the form
                                                                this.getTopParentView().hide(); // Hides the popup
                                                            } else {
                                                                webix.message({
                                                                    title: '¡Error!',
                                                                    type: 'alert-error',
                                                                    text: 'Completa los campos...', // Validation error message
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function() {
                                                    this.validate(); // Validates the form on change
                                                },
                                            },
                                        },
                                    },
                                });
                            },
                        });
                },
            });

        // Listen for the 'incomes:filter' event on the app instance
        this.on(this.app, 'incomes:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string

            // Iterate through each key-value pair in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        // Handle 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query string
                        } else {
                            // Add other filters to query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate through each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date in the nested object
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create Date object from value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format year
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' + // Format month
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' + // Format day
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' + // Format hours
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' + // Format minutes
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    // Handle 'end' date in the nested object
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create Date object from value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format year
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' + // Format month
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' + // Format day
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' + // Format hours
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' + // Format minutes
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user ID to query string
            grid.clearAll(); // Clear existing grid data
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Set the starting index and page size for pagination
                filter + // Apply any existing filters
                '&sort[' +
                by + // Specify the field to sort by
                ']=' +
                dir, // Specify the direction of sorting (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item using its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                grid.data.url +
                '?start=0&count=' +
                grid.data.$pagesize + // Set the starting index and page size for pagination
                '&PlayerId=' +
                Id, // Filter the data by the selected player's ID
            );
        });
        // Create a popup window for editing income entries
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            width: 750, // Set the width of the window
            id: 'EditIncomes', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: 'Editar Gasto' }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function() {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'editForm', // Unique identifier for the form
                elements: [
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for ID
                                label: 'ID', // Label for the input
                                name: 'Id', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Description
                                label: 'Descripción', // Label for the input
                                name: 'Description', // Name of the input field
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for Creation Date
                                label: 'Fecha de Creación', // Label for the input
                                labelWidth: 140, // Width of the label
                                name: 'CreatedLocalDate', // Name of the input field
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Income Type
                                label: 'Tipo de Ingreso', // Label for the input
                                name: 'TypeIncomes', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for Document ID
                                label: 'Documento ID', // Label for the input
                                name: 'DocumentID', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'combo', // Combo box for Concept
                                label: 'Concepto', // Label for the input
                                name: 'Concept', // Name of the input field
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for Value
                                label: 'Valor', // Label for the input
                                name: 'Value', // Name of the input field
                                type: 'number', // Input type is number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for IVA
                                label: 'IVA', // Label for the input
                                name: 'Iva', // Name of the input field
                                type: 'number', // Input type is number
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for Retracción
                                label: 'Retracción', // Label for the input
                                name: 'Retraccion', // Name of the input field
                                type: 'number', // Input type is number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Button for Cancel action
                                value: 'Cancelar', // Button label
                                click: function() {
                                    // Click event for the button
                                    this.getTopParentView().hide(); // Hide the window
                                   $$('editForm').setValues(
                                        // Reset the form values
                                       $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for Save action
                                type: 'form', // Button type is form
                                value: 'Guardar', // Button label
                                click: function($e) {
                                    // Click event for the button
                                    var values =$$('editForm').getValues(); // Get form values
                                    webix // Make an AJAX request to save the data
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint
                                            'BetShop/Incomes',
                                            '{"Id":"' +
                                            values.Id +
                                            '", "IsBetShop":"' +
                                            values.IsBetShop +
                                            '", "Description":"' +
                                            values.Description +
                                            '", "CreatedLocalDate":"' +
                                            values.CreatedLocalDate +
                                            '", "TypeIncomes":"' +
                                            values.TypeIncomes +
                                            '"  , "BetShop":"' +
                                            cur_user +
                                            '"  , "DocumentID":"' +
                                            values.DocumentID +
                                            '"  , "Value":"' +
                                            values.Value +
                                            '", "Iva":"' +
                                            values.Iva +
                                            '", "Retraccion":"' +
                                            values.Retraccion +
                                            '"}',
                                            {
                                                error: function(text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function(text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        'Gasto Actualizado', // Show success message
                                                    );
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                   $$('editForm').setValues(
                                        // Reset the form values
                                       $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for the 'AddIncome:button' event on the application instance
        this.on(this.app, 'AddIncome:button', (filter) => {
            // Clear any validation messages on the 'addform'
            $$('addform').clearValidation();
            // Show the popup for adding income
            popupAdd.show();
        });
        // Bind the 'editForm' to the 'datatable' for data manipulation
       $$('editForm').bind($$('datatable')); // Placeholder for initialization content
    }
}

// FILE DOCUMENTED
